/**
 * useFaceToIdTransition Hook
 * Subscribes React components to the face-to-ID transition owner.
 */

import { useSyncExternalStore } from 'react';
import {
  faceToIdTransition,
  type FaceToIdTransitionState,
} from '../core/FaceToIdTransition';

export function useFaceToIdTransition(): FaceToIdTransitionState {
  return useSyncExternalStore(
    faceToIdTransition.subscribe,
    faceToIdTransition.getState
  );
}
